<template>
  <!-- odjavljen posetilac (svi ekrani): "Prijava" vodi pravo na /login; prijavljen i dalje dobija padajuci meni -->
  <NuxtLink v-if="useStore.loggedIn === false" to="/login" class="pf-guest-link">
    <i class="esei icon-user-solid" aria-hidden="true"></i>
    Prijavi se
  </NuxtLink>

  <BDropdown
    :class="{ 'd-none': useStore.loggedIn === false }"
    class="d-inline-block btn-drop custom-dropdown"
    toggle-class="header-item custom-dropdown-toggle"
    right
    variant="white"
    id="my-btn-drop"
    ref="dropdown"
    menu-class="dropdown-menu-end custom-dropdown-menu"
  >
    <template #button-content>
      <!-- Mobile -->
      <div class="d-xl-none d-lg-none d-md-none d-sm-flex d-flex align-items-center gap-2">
        <div class="avatar-modern">
          <span v-if="useStore.loggedIn !== false">
            {{ nameAvatar() }}
          </span>
          <i v-else class="esei icon-user-solid"></i>
        </div>

        <span class="trigger-text" :class="triggerTextClass">
          {{ emailUser() }}
        </span>

        <i class="esei icon-chevron-down trigger-chevron"></i>
      </div>

      <!-- Desktop -->
      <div class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-none align-items-center gap-2 dropdown-trigger">
        <div class="avatar-modern">
          <span v-if="useStore.loggedIn !== false">
            {{ nameAvatar() }}
          </span>
          <i v-else class="esei icon-user-solid"></i>
        </div>

        <span class="trigger-text" :class="triggerTextClass">
          {{ emailUser() }}
        </span>

        <i class="esei icon-chevron-down trigger-chevron"></i>
      </div>
    </template>

    <!-- User info -->
    <div v-if="useStore.loggedIn !== false" class="dropdown-user-box">
      <div class="dropdown-user-email">
        <i class="esei icon-envelope dropdown-user-email-icon"></i>
        <span>{{ useStore.customer?.email }}</span>
      </div>
      <hr class="dropdown-separator" />
    </div>

    <!-- Main menu -->
    <NuxtLink
      v-for="m in menuByMenu"
      :key="m.id"
      :to="m.link2"
      class="dropdown-item custom-dropdown-item"
      :class="{ 'custom-dropdown-item-special': m.id === 55 }"
    >
      <i :class="`${m.icon} custom-dropdown-icon`" aria-hidden="true"></i>
      <span class="custom-dropdown-text">{{ m.label }}</span>
    </NuxtLink>

    <!-- Logged in -->
    <div v-if="useStore.loggedIn !== false">
      <button
        v-for="m in menuOut"
        :key="m.id"
        type="button"
        class="dropdown-item custom-dropdown-item custom-dropdown-button"
        @click="logOutCustomer"
      >
        <i :class="`${m.icon} custom-dropdown-icon`" aria-hidden="true"></i>
        <span class="custom-dropdown-text">{{ m.label }}</span>
      </button>
    </div>

    <!-- Logged out -->
    <div v-else>
      <NuxtLink
        v-for="m in menuIn"
        :key="m.id"
        :to="m.link2"
        class="dropdown-item custom-dropdown-item"
        :class="{ 'custom-dropdown-item-special': m.id === 55 }"
        @click="dropdownDisable"
      >
        <i :class="`${m.icon} custom-dropdown-icon`" aria-hidden="true"></i>
        <span class="custom-dropdown-text">{{ m.label }}</span>
      </NuxtLink>
    </div>
  </BDropdown>
</template>

<script setup>
import { computed } from 'vue'
import { BDropdown } from 'bootstrap-vue-next'
import { useCustomerLoginStore } from '~/stores/login/customer'
import { menuItems } from '../utils/menu-cms'

const { session, reset, update } = await useSession()
const router = useRouter()
const nuxtApp = useNuxtApp()

const useStore = useCustomerLoginStore()

const menuByMenu = computed(() => menuItems.filter(x => x.menu))
const menuOut = computed(() => menuItems.filter(x => x.logout))
const menuIn = computed(() => menuItems.filter(x => x.login))

const nameAvatar = () => {
  if (useStore.loggedIn === false || !useStore.customer?.name) return ''

  const parts = useStore.customer.name.trim().split(' ')
  return parts.length > 1
    ? `${parts[0][0]}${parts[1][0]}`
    : `${parts[0][0]}`
}

const emailUser = () => {
  return useStore.loggedIn !== false && useStore.customer?.email
    ? `${useStore.customer.email.split('@')[0]}@`
    : 'Prijavi se'
}

// prijavljen korisnik: na manjim ekranima (ispod lg) ostaje samo krug sa inicijalima, mejl tek od lg;
// "Prijavi se" (odjavljen korisnik) ostaje vidljivo na svim ekranima
const triggerTextClass = computed(() =>
  useStore.loggedIn !== false ? 'd-none d-lg-inline' : ''
)

const logOutCustomer = async () => {
  await useStore.logOutCustomer()
}

const dropdownDisable = () => {}
</script>

 